import Vue from 'vue'
import Router from 'vue-router'
import home from './views/home'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/merchant/apply',
      name: 'apply',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/apply/index.vue')
    },
    {
      path: '/smtp',
      name: 'smtp',
      component: () => import('./views/smtp/index.vue')
    }
  ]
})
